import * as React from "react";
import {TrackerPolicy} from "@models/tracker-policy";
import Table from "@components/subscriptions/Table";
import {Button, Card} from "antd";
import {FormattedMessage} from "react-intl";
import SearchComponent from "@components/subscriptions/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import subscriptionApi from "@api/subscription";
import withPaginationComponent from "@hocs/withPaginationComponent";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";
import {SubscriptionStatus} from "../../models/subscription";



interface PropsFromHoc {
  data          :TrackerPolicy[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}


const ListPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  const deleteTrackerPolicy = (item: TrackerPolicy): any => {
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/subscriptions/create`}>
          <Button type={"primary"}>
            <FormattedMessage
              id="app.new_subscription"
              defaultMessage={`Create New Subscription`}
            />
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteTrackerPolicy}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ListPage),
  {
    fetchRequest: subscriptionApi.getList,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);
